const FAQSection = function() {
    function FAQSection() {
        this.selector = {
            collapsable: document.querySelectorAll(".section-container > .collapsable-columns > .collapsable-column > ul > li > button, .faq button")
        }
        this.load();
    }
    FAQSection.prototype.load = function() {
        var _ = this;
        if(_.selector.collapsable.length > 0) {
            _.selector.collapsable.forEach(btn => {
                btn.addEventListener("click", event => {
                    console.log(event.target);
                    event.target.closest("li").classList.toggle("active");
                })
            })
        }
    }
    FAQSection = new FAQSection;
}
FAQSection();